<template>
  <section class="familyView">
    <div class="content">
      <div v-for="(items, index) in imgs" :key="index" :class="'li' + (index + 1)" >
        <div :ref="'items'+ (index + '' + idx)" v-for="(item, idx) in items" :key="idx" :class="item.name?item.name:item"  @mouseover="mouse(index, idx)" @mouseleave="mouse('')" style="position: relative;">
          <div :ref="'items'+ (index + '' + idx + '' + childIdx)" v-show="item.name" v-for="(child, childIdx) in item.cls" :key="childIdx" :class="child" @mouseover.stop="childmouse(index, idx, childIdx)" @mouseleave="childmouse('')" style="position: relative;">
            <div class="line" v-show="activeIdx === index+''+idx+''+childIdx" :style="lineStyle">
            </div>
            <div class="text" :class="activeIdx === index+''+idx+''+childIdx ? 'active':''"  :style="lineStyle">
              <img src="../../assets/img/LogoApp.png" alt="">
              <p>{{text[activeIdx]}}</p>
            </div>
          </div>
          <div class="line" v-show="activeIdx === index+''+idx && !item.name" :style="lineStyle">
          </div>
          <div class="text" :class="activeIdx === index+''+idx && !item.name?'active':''" :style="lineStyle" style="position: relative;">
            <img src="../../assets/img/LogoApp.png" alt="">
            <p>{{text[activeIdx]}}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    data() {
      return {
        text: {
          '000': '新年写福送福','001': '乐璟露天电影', '01': '乐璟王者荣耀争霸赛', '02': '乐璟篮球赛', '10': '乐璟公益露天市集', '11': '乐璟音乐啤酒节', '20': '乐跑活动', '21': '我和我的祖国 乐璟集体观影', '30': '乐璟公益课堂', '31':'母亲节活动'
        },
        imgs: [
          [{name: 'left', cls: ['top', 'bottom']}, 'middle', 'right'],
          ['left', 'right'],
          ['left', 'right'],
          ['left', 'right']
          // ['left', {name: 'right', cls: ['top', 'bottom']}],
          // [{name: 'left', cls: ['top', 'bottom']}, 'right'],
        ],
        activeIdx: '',
        lineStyle: {}
      }
    },
    methods: {
      mouse(index, idx) {
        if(index === ''){
          this.activeIdx = ''
          return
        }
        let el = this.$refs[`items${index}${idx}`][0]
        this.lineStyle.width = el.clientWidth*0.8 +'px'
        this.lineStyle.height = el.clientHeight*0.8 + 'px'
        this.lineStyle.left = `calc(50% - ${el.clientWidth*0.8 / 2}px)`
        this.lineStyle.top = `calc(50% - ${el.clientHeight*0.8 / 2}px)`
        this.activeIdx = `${index}${idx}`
      },
      childmouse(index, idx, childIdx) {
        if(index === ''){
          this.activeIdx = ''
          return
        }
        let el = this.$refs[`items${index}${idx}${childIdx}`][0]
        this.lineStyle.width = el.clientWidth*0.8 +'px'
        this.lineStyle.height = el.clientHeight*0.8 + 'px'
        this.lineStyle.left = `calc(50% - ${el.clientWidth*0.8 / 2}px)`
        this.lineStyle.top = `calc(50% - ${el.clientHeight*0.8 / 2}px)`
        // this.$set(this.activeIdx, `${index}${idx}${childIdx}`)
        // this.activeIdx =
        this.activeIdx = `${index}${idx}${childIdx}`
        console.log('childIdx', `${index}${idx}${childIdx}`, this.activeIdx)
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .familyView
    font-family PingFangSC-Regular
    background-color #FFFFFF
    padding 104px 0 166px 0
    .content
      width 1120px
      margin 0 auto
      .active
        transition all 0.3s
        transform: scale(1)!important
      .text
        transition all 0.3s
        transform: scale(0)
        position absolute
        img
          width: 88px
          height: 22px
          position: absolute
          top: calc(50% - 40px)
          left: calc(50% - 44px)
        p
          position: absolute
          top: calc(50% - 11px)
          left: calc(50% - 150px)
          width: 300px
          text-align center
          font-size 22px
          margin-top 10px
          color #fff
      .line
        position absolute
        background-color #137BA2
        opacity 0.7
      .li1
        display flex
        height 471px
        justify-content space-between
        .left
          width 386px
          .top
            height 235px
            background url(../../assets/img/lejj_1.png)
          .bottom
            margin-top 5px
            height 230px
            background url(../../assets/img/lejj_2.png)
        .middle
          width 389px
          background url(../../assets/img/lejj_3.png)
        .right
          width 335px
          background url(../../assets/img/lejj_4.png)
      .li2
        margin-top 5px
        display flex
        height 303px
        justify-content space-between
        .left
          background url(../../assets/img/lejj_5.png)
          width 503px
        .right
          background url(../../assets/img/lejj_6.png)
          width 609px
      .li3
        margin-top 5px
        display flex
        height 433px
        justify-content space-between
        .left
          background url(../../assets/img/lejj_7.png)
          width 384px
        .right
          background url(../../assets/img/lejj_8.png)
          width 729px
      .li4
        margin-top 5px
        display flex
        height 420px
        justify-content space-between
        .left
          background url(../../assets/img/lejj_9.png)
          width 469px
        .right
          width 645px
          background url(../../assets/img/lejj_10.png)
      .li5
        margin-top 5px
        display flex
        height 592px
        justify-content space-between
        .left
          width 555px
          .top
            height 303px
            background url(../../assets/img/lejj_12.png)
          .bottom
            margin-top 5px
            height 284px
            background url(../../assets/img/lejj_13.png)
        .right
          width 560px
          background url(../../assets/img/lejj_14.png)
</style>
